import axios from "axios";

import { API_URLS } from "src/utils/API_URLS";

const PaymentsService = {
  create: async <T>(data: T): Promise<void> => {
    try {
      const url = API_URLS.createSingleSplitPayments;
      await axios.post(url, data);
    } catch (error) {
      console.error(error);
      throw error;
    }
  },
};

export default PaymentsService;
